import { render } from "./zqTopicCheck.vue?vue&type=template&id=9bb64eda&scoped=true"
import script from "./zqTopicCheck.vue?vue&type=script&lang=js"
export * from "./zqTopicCheck.vue?vue&type=script&lang=js"

import "./zqTopicCheck.vue?vue&type=style&index=0&id=9bb64eda&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bb64eda"]])

export default __exports__